import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormControl from '@mui/material/FormControl';
import { Chip, Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import CreateApi from './CreateApi';
import useStyles from '../styles';
import { updateFrom } from '../../../redux/Actions/createInstance.action';
import { ADD_USAGE_LIMIT } from '../../../redux/Constants/createInstance.constants';

const HeadTextField = styled(TextField)(() => ({
    marginLeft: '15px',
    marginTop: '12px',
    input: {
        height: '1px',
        // padding: '15px 10px',
        border: '1px 1px solid #70707063',
        borderRadius: '0px !important'
    }
}));

const usageValsSearch = {
    minute: 60,
    hourly: 3500,
    monthly: 300000
};

const usageValsAnalytics = {
    minute: 50,
    hourly: 2500,
    monthly: 150000
};

const usageValsContent = {
    minute: 50,
    hourly: 2500,
    monthly: 150000
};

const usageValsChatbot = {
    minute: 0,
    hourly: 0,
    monthly: 0
};

export default function UsageLimit(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isChatBotEnabled, setIsChatBotEnabled] = useState(false);
    const { isEditable } = props;
    const [usages, setUsages] = useState({
        apiUsagePerSecond: 5,
        searchApiLimit: usageValsSearch,
        analyticsApiLimit: usageValsAnalytics,
        contentApiLimit: usageValsContent,
        chatbotApiLimit: usageValsChatbot
    });

    const allApps = useSelector((state) => state.applicationsReducer.allApps);
    const clientInfo = useSelector((state) => state.clientReducer.clientInfo);

    const usageChange = (val, time) => (e) => {
        setUsages({
            ...usages,
            [val]: {
                ...usages[val],
                [time]: e.target.value
            }
        });
    };
    const decimalVal = (event) => {
        if (event.key === '.' || event.key === '-') {
            event.preventDefault();
        }
    };

    const handleChange = (val) => (e) => {
        setUsages({
            ...usages,
            [val]: e.target.value
        });
    };

    useEffect(() => {
        dispatch(updateFrom(usages, ADD_USAGE_LIMIT));
    }, [usages, dispatch]);

    useEffect(() => {
        const chatBotAppId = allApps.find((aP) => aP.name.toLowerCase() === 'chatbot analytics');
        if (
            (chatBotAppId &&
                clientInfo.installedApps &&
                clientInfo.installedApps.includes(chatBotAppId._id)) ||
            !isEditable
        ) {
            setIsChatBotEnabled(true);
        } else {
            setIsChatBotEnabled(false);
        }
    }, [clientInfo, allApps, isEditable]);

    useEffect(() => {
        if (props.val.usages) {
            const data = props.val.usages;
            setUsages({
                apiUsagePerSecond: data.apiUsagePerSecond,
                searchApiLimit: data.searchApiLimit,
                analyticsApiLimit: data.analyticsApiLimit,
                contentApiLimit: data.contentApiLimit,
                chatbotApiLimit: data.chatbotApiLimit
            });
        }
    }, [props.val]);

    return (
        <div className={classes.formContainer}>
            <h1 className={classes.heading}>API Usage Limit</h1>
            <Grid container>
                <div className={classes.secondHeadApi}>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.innerheadApi}>
                            <Chip
                                style={{
                                    background: '#58C1FE ',
                                    color: ' #FFFFFF'
                                }}
                                className={classes.innerText}
                                label="CONCURRENT API REQUESTS"
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.nextSet}>
                            <div className={classes.formTextApi}>Limit Per Second</div>
                            <FormControl sx={{ width: 120 }}>
                                <HeadTextField
                                    type="number"
                                    id="outlined-basic"
                                    variant="outlined"
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    onKeyDown={decimalVal}
                                    error={
                                        usages.apiUsagePerSecond < 0 ||
                                        usages.apiUsagePerSecond === ''
                                    }
                                    helperText={
                                        (usages.apiUsagePerSecond < 0 && 'Invalid data') ||
                                        (usages.apiUsagePerSecond === '' && 'Field cannot be empty')
                                    }
                                    InputProps={{ inputProps: { min: 0 } }}
                                    value={usages.apiUsagePerSecond}
                                    onChange={handleChange('apiUsagePerSecond')}
                                    InputLabelProps={{
                                        style: { fontSize: '13px' }
                                    }}
                                />
                            </FormControl>
                        </div>
                    </Grid>
                </div>
            </Grid>
            <div className={classes.boxSet}>
                <Grid container>
                    <Grid item xs={12} sm={6} md={4}>
                        <CreateApi
                            label="Search"
                            name="searchApiLimit"
                            value={usages.searchApiLimit}
                            usageChange={usageChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        {' '}
                        <CreateApi
                            label="Analytics"
                            name="analyticsApiLimit"
                            value={usages.analyticsApiLimit}
                            usageChange={usageChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        {' '}
                        <CreateApi
                            label="Content"
                            name="contentApiLimit"
                            value={usages.contentApiLimit}
                            usageChange={usageChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        {' '}
                        {isChatBotEnabled && (
                            <CreateApi
                                label="Chatbot Analytics"
                                name="chatbotApiLimit"
                                value={usages.chatbotApiLimit}
                                usageChange={usageChange}
                            />
                        )}
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}
